import { render, staticRenderFns } from "./ViewTemplatesHome.vue?vue&type=template&id=38fee000&"
import script from "./ViewTemplatesHome.vue?vue&type=script&lang=js&"
export * from "./ViewTemplatesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports